import React, { useContext } from 'react';
import { SaveJobButton } from 'module-tsl-ui-jobs-save-job-button';
import { JobContext } from '../JobContext';
export var CallToAction = function CallToAction() {
  var _useContext = useContext(JobContext),
      forceSmall = _useContext.forceSmall,
      customCta = _useContext.customCta,
      jobId = _useContext.jobId,
      shouldPubSub = _useContext.shouldPubSub,
      i18n = _useContext.i18n,
      isMobile = _useContext.isMobile;

  if (customCta) return customCta;
  return /*#__PURE__*/React.createElement(SaveJobButton, {
    jobId: jobId,
    shouldPubSub: shouldPubSub,
    i18n: i18n,
    size: isMobile ? 'sm' : 'md',
    theme: "tertiary",
    iconOnly: forceSmall
  });
};
CallToAction.displayName = "CallToAction";